import { FC } from 'react';

import { Position, PsychicCardAppearance } from 'constants/enums';
import { PsychicCardImage } from 'entities/PsychicCardImage';
import { HeartImage } from 'entities/PsychicHeartImage';
import { PsychicCardVideo } from 'entities/PsychicCardVideo';
import { DataLink } from 'components/Shared/SharedComponents';
import { PsychicCardLabel } from 'entities/PsychicCardLabel';

import styles from './PsychicCardTile.module.scss';

import type { IPsychicImage } from '../config/declarations';

const MainImage: FC<IPsychicImage> = ({
  psychic,
  psychicFrame,
  positionInArray,
  linkProps,
}) => {
  const imageUrl = psychic.images[2] || psychic.psychicImageUrl || psychicFrame.avatar?.url || '';

  return (
    <DataLink
      link={linkProps?.profileLink!}
      href={linkProps?.profileUrl}
      gaData={linkProps?.gaData}
      className={styles.imageWrapper}
    >
      <PsychicCardImage
        loading={positionInArray === Position.RIGHT ? 'lazy' : 'eager'}
        psychic={psychicFrame}
        image="external"
        src={imageUrl}
        alt={psychic.psychicName}
        className={styles.image}
      />
      <PsychicCardLabel
        psychic={psychic}
        psychicFrame={psychicFrame}
        className={styles.label}
      />
      <HeartImage
        psychic={psychic}
        contentfulData={psychicFrame}
        className={styles.heart}
        assetClassName={styles.heartAsset}
        assetFavoriteClassName={styles.heartAssetFavorite}
        hintClassName={styles.heartHint}
        hintArrowClassName={styles.heartHintArrow}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
      />
      {psychic?.psychicVideoURL && (
        <PsychicCardVideo
          psychic={psychic}
          view={PsychicCardAppearance.TILE}
          className={styles.video}
        />
      )}
    </DataLink>
  );
};

export default MainImage;
